import React, { useEffect, useState } from 'react';
import {
  CircularProgress,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import UpIcon from '@material-ui/icons/KeyboardArrowUp';
import { FormattedMessage, useIntl } from 'react-intl';
import { Redirect } from 'react-router-dom';
import SortAsc from '../../assets/images/llantas/table/sort-asc.svg';
import SortDesc from '../../assets/images/llantas/table/sort-desc.svg';
import Sort from '../../assets/images/llantas/table/sort.svg';
import { StyledTableCellProps as StyledTableCell, StyledTooltip } from '../../commons/utils/TableStyles.js';
import * as Utils from '../../commons/utils/Utils.js';
import ItemClasificacionesGridRow from './ItemClasificacionesGridRow.jsx';
import ItemClasificacionesGridFiltros from './ItemClasificacionesGridFiltros.jsx';
import Security from '../../commons/security/Security.js';
import ConfigBusiness from '../../commons/config/ConfigBusiness.js';

const PAGINATION_INIT = { page: 0, count: 0, perPage: 10 };
const FILTER_QUERY_INIT = { nombre: '', showInactivos: false, tipoItem: '' };
const SORT_QUERY_INIT = { nombre: '', id: 'desc' };

const ItemClasificacionesGrid = (props) => {
  const intl = useIntl();

  const [loading, setLoading] = useState(false);
  const [redirectTo, setRedirectTo] = useState(null);

  const [searchActive, setSearchActive] = useState(false);
  const [pagination, setPagination] = useState({ ...PAGINATION_INIT });
  const [count, setCount] = useState(0);

  const [filterResetInputs, setFilterResetInputs] = useState(false);
  const [filterQuery, setFilterQuery] = useState({ ...FILTER_QUERY_INIT });

  const [sortQuery, setSortQuery] = useState({ ...SORT_QUERY_INIT });
  const [dropdownActive, setDropdownActive] = useState(false);

  const [rows, setRows] = useState([]);

  const [permissions, setPermissions] = useState({
    crear: false,
    visualizar: false,
    modificar: false,
    eliminar: false,
  });

  useEffect(() => {
    setLoading(true);
    if (Security.hasPermission('ITEMS_CLASIFICACIONES_LISTAR') && ConfigBusiness.get('panol.items.clasificacion.habilitado') === 'true') {
      securityPermission();
      fetchRows();
    } else {
      setRedirectTo('/error');
    }
    return () => {};
  }, [pagination, filterQuery, sortQuery]);

  const securityPermission = () => {
    let aux = { ...permissions };
    aux.crear = Security.hasPermission('ITEMS_CLASIFICACIONES_CREAR');
    aux.modificar = Security.hasPermission('ITEMS_CLASIFICACIONES_MODIFICAR');
    aux.visualizar = Security.hasPermission('ITEMS_CLASIFICACIONES_VISUALIZAR');
    aux.eliminar = Security.hasPermission('ITEMS_CLASIFICACIONES_ELIMINAR');
    setPermissions(aux);
  };

  const fetchRows = () => {
    Utils.getData(`/item/clasificaciones${getQuery()}`)
      .then((data) => {
        setRows(data.clasificaciones || data.rows || []);
        setCount((data.pagination && data.pagination.count) || 0);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  const getQuery = () => {
    let query = '?page=' + (pagination.page+1); // +1 porque la API espera como página base la 1 (para el front es 0)
    query += '&perPage=' + pagination.perPage;
    query += '&nombre=' + (filterQuery.nombre || '');
    query += '&showInactivos=' + (filterQuery.showInactivos || false);
    if (filterQuery.tipoItem) query += '&tipoItem=' + filterQuery.tipoItem;
    query += '&nombreSort=' + (sortQuery.nombre || '');
    query += '&idSort=' + (sortQuery.id || '');
    return query;
  };

  const handleChangePage = (event, newPage) => {
    setPagination({ ...pagination, page: newPage });
  };

  const handleChangeRowsPerPage = (event) => {
    setPagination({ ...pagination, perPage: parseInt(event.target.value, 10), page: 0 });
  };

  const requestSort = (key) => {
    let query = { ...sortQuery };
    let aux = sortQuery[key];
    query['nombre'] = '';
    query['id'] = '';
    if (!aux) query[key] = 'asc';
    else if (aux === 'desc') query[key] = 'asc';
    else query[key] = 'desc';
    setPagination({ ...pagination, page: 0 });
    setSortQuery(query);
  };

  const handleFilterReset = () => {
    setPagination(PAGINATION_INIT);
    setFilterQuery(FILTER_QUERY_INIT);
    setDropdownActive(false);
    setSortQuery(SORT_QUERY_INIT);
    setSearchActive(false);
    setFilterResetInputs(true);
  };

  const handleFilterChange = () => {
    setPagination((prevState) => ({ ...prevState, page: 0 }));
  };

  return (
    <>
      {redirectTo && <Redirect push to={redirectTo} />}
      <div className="row mt-2">
      <div className="col-12">
      <div className="card">
        <div className="card-content collpase show">
          <div className="card-body card-dashboard">
            <div className="container-fluid">
              <div className="row dt-icons">
                <div className="col">
                  {permissions.crear && (
                    <StyledTooltip
                      title={intl.formatMessage({ id: 'Nuevo', defaultMessage: 'Nuevo' })}
                      arrow
                      placement="right"
                    >
                      <div
                        className="btn btn-primary box-shadow-2 btn-round btn-lg btn-dt-main round-icon"
                        style={{ height: 55 }}
                        onClick={() => setRedirectTo(props.match.url + '/add')}
                      >
                        <i className="ft-plus"></i>
                      </div>
                    </StyledTooltip>
                  )}
                  <div
                    className="btn btn-grey-blue box-shadow-2 btn-round btn-lg btn-dt-main round-icon"
                    onClick={() => setDropdownActive(!dropdownActive)}
                  >
                    {dropdownActive ? <UpIcon /> : <ExpandMoreIcon />}
                  </div>
                </div>
                <div className="col">
                  {searchActive && (
                    <div className="btn-dt-main round-icon">
                      <div
                        className="text-center"
                        style={{
                          height: '25px',
                          borderRadius: '3px',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          paddingLeft: '8px',
                          backgroundColor: '#5AAC43',
                          color: 'white',
                        }}
                      >
                        <div className="text-center" style={{ width: '100%', fontSize: '12px', fontWeight: '500' }}>
                          {intl.formatMessage(
                            { id: 'search.results', defaultMessage: '{shown} de {total} resultados de búsqueda' },
                            { shown: rows.length, total: count }
                          )}
                        </div>
                        <div className="resultados-busqueda-notif">
                          <i className="las la-times la-xs cursor-pointer" onClick={() => handleFilterReset()}></i>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <ItemClasificacionesGridFiltros
              dropdownActive={dropdownActive}
              setDropdownActive={setDropdownActive}
              filterResetInputs={filterResetInputs}
              setFilterResetInputs={setFilterResetInputs}
              filterQuery={filterQuery}
              setFilterQuery={setFilterQuery}
              searchActive={searchActive}
              setSearchActive={setSearchActive}
              pagination={pagination}
              handleFilterChange={handleFilterChange}
              loading={loading}
            />

            <TableContainer>
              <Table aria-label="item clasificaciones table" className="table-hover">
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="left" onClick={() => requestSort('id')} style={{ width: '50px' }}>
                      <FormattedMessage id="Id" defaultMessage="Id" />
                      <img className="ml-1" src={sortQuery.id === '' ? Sort : sortQuery.id === 'asc' ? SortAsc : SortDesc} alt={'/'} style={{ height: '12px', width: '22px' }} />
                    </StyledTableCell>
                    <StyledTableCell align="left" onClick={() => requestSort('nombre')} style={{ cursor: 'pointer' }}>
                      <FormattedMessage id="itemClasificacion" defaultMessage="Clasificación" />
                      <img className="ml-1" src={sortQuery.nombre === '' ? Sort : sortQuery.nombre === 'asc' ? SortAsc : SortDesc} alt={'/'} style={{ height: '12px', width: '22px' }} />
                    </StyledTableCell>
                    {ConfigBusiness.get('tickets.trabajaConManoDeObra.habilitado') === 'true' && (
                      <StyledTableCell align="left" style={{ width: '220px' }}>
                        <FormattedMessage id="itemClasificaciones.render.column_aplica_a.label" defaultMessage="Aplica a" />
                      </StyledTableCell>
                    )}
                    <StyledTableCell align="center" style={{ width: '150px' }}>
                      <FormattedMessage id="itemClasificaciones.render.column_acciones.label" defaultMessage="Acciones" />
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading && (
                    <TableRow>
                      <StyledTableCell colSpan={ConfigBusiness.get('tickets.trabajaConManoDeObra.habilitado') === 'true' ? 4 : 3} align="center">
                        <CircularProgress />
                      </StyledTableCell>
                    </TableRow>
                  )}
                  {!loading &&
                    (rows.length > 0 ? (
                      rows.map((row) => (
                        <ItemClasificacionesGridRow
                          intl={intl}
                          key={'GridRow_' + row.id}
                          baseUrl={props.match.url}
                          row={row}
                          fetchRows={fetchRows}
                          permissions={permissions}
                        />
                      ))
                    ) : (
                      <TableRow>
                        <StyledTableCell colSpan={ConfigBusiness.get('tickets.trabajaConManoDeObra.habilitado') === 'true' ? 4 : 3} align="center">
                          <FormattedMessage id="itemClasificaciones.render.no_data_table" defaultMessage="No se encontraron resultados..." />
                        </StyledTableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50, 100]}
              component="div"
              count={count}
              rowsPerPage={pagination.perPage}
              page={pagination.page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              labelRowsPerPage={intl.formatMessage({ id: 'Mostrar', defaultMessage: 'Mostrar' })}
              labelDisplayedRows={({ from, to, count }) => 
                intl.formatMessage(
                  { id: 'pagination.displayedRows', defaultMessage: 'Mostrando {from} a {to} de {count}' },
                  { from, to, count }
                )
              }
            />
          </div>
        </div>
      </div>
      </div>
      </div>
    </>
  );
};

export default ItemClasificacionesGrid;


